/* ============================================================
   VAMORA — Product Page Prototype (Phase A) controller
   Vanilla JS. One shared product state drives every visual
   instance (floating / inline / desktop purchase bars, and the
   in-sheet variant pickers). No production data is hard-coded —
   everything is read from mock-product.json and clearly demo.
   ============================================================ */
(function () {
  "use strict";

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- SVG icon family (single consistent set) ---------- */
  const ICONS = {
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 7h14l-1.1 12.6a1.5 1.5 0 0 1-1.5 1.4H7.6a1.5 1.5 0 0 1-1.5-1.4z"/><path d="M8.5 7V5.5a3.5 3.5 0 0 1 7 0V7"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 20s-7-4.5-9.3-8.2C1 8.9 2.4 5.6 5.6 5.6c1.9 0 3.1 1.1 3.9 2.2.8-1.1 2-2.2 3.9-2.2 3.2 0 4.6 3.3 2.9 6.2C19 15.5 12 20 12 20z"/></svg>',
    heartFill: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 20s-7-4.5-9.3-8.2C1 8.9 2.4 5.6 5.6 5.6c1.9 0 3.1 1.1 3.9 2.2.8-1.1 2-2.2 3.9-2.2 3.2 0 4.6 3.3 2.9 6.2C19 15.5 12 20 12 20z"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    chevronRight: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    chevronDown: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>',
    discount: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 9h.01M15 15h.01M15 9l-6 6"/><path d="M3 12l2-2-1-3 3-.5L8 1l3 1 2-1 2 1 3-.5.5 3 1 3-2 2 2 2-1 3-3 .5L15 23l-3-1-2 1-2-1-3 .5-.5-3-1-3 2-2z"/></svg>',
    bolt: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L4.5 13H11l-1 9 8.5-11H12l1-9z"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6 6.6.6-5 4.3 1.5 6.5L12 16.9 5.9 19.4 7.4 12.9l-5-4.3L9 8z"/></svg>',
    starHalf: '<svg viewBox="0 0 24 24"><defs><linearGradient id="sh"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs><path fill="url(#sh)" stroke="currentColor" stroke-width="1" d="M12 2l2.9 6 6.6.6-5 4.3 1.5 6.5L12 16.9 5.9 19.4 7.4 12.9l-5-4.3L9 8z"/></svg>',
    starOutline: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 2l2.9 6 6.6.6-5 4.3 1.5 6.5L12 16.9 5.9 19.4 7.4 12.9l-5-4.3L9 8z"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7h11v9H2zM13 10h4l4 3v3h-8"/><circle cx="6.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>',
    ret: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8h13a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4H8"/><path d="M6 5L3 8l3 3"/></svg>',
    cod: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="16" height="11" rx="2"/><circle cx="10" cy="11.5" r="2.4"/><path d="M22 9v9a2 2 0 0 1-2 2H6"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M7 7v3M12 7v4M17 7v3" stroke-linecap="round"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>',
    verified: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.4 1.8 3 .1 1 2.8 2.4 1.7-.9 2.9.9 2.9-2.4 1.7-1 2.8-3 .1L12 22l-2.4-1.8-3-.1-1-2.8L3.2 15l.9-2.9L3.2 9l2.4-1.7 1-2.8 3-.1z"/><path d="M8 12l2.5 2.5L16 9" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    trend: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7l7 7 4-4 7 7"/><path d="M21 17v-5h-5"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>',
    laurelL: '<svg viewBox="0 0 24 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M20 4C10 8 6 18 8 30c1 8 5 12 12 14"/><path d="M18 10c-5 0-7 3-7 3M16 18c-5 0-7 3-7 3M15 27c-5 0-7 3-7 3M16 36c-4 0-6 3-6 3"/></svg>',
    laurelR: '<svg viewBox="0 0 24 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 4C14 8 18 18 16 30c-1 8-5 12-12 14"/><path d="M6 10c5 0 7 3 7 3M8 18c5 0 7 3 7 3M9 27c5 0 7 3 7 3M8 36c4 0 6 3 6 3"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></svg>',
    sliders: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"/><circle cx="9" cy="6" r="2" fill="currentColor" stroke="none"/><circle cx="15" cy="12" r="2" fill="currentColor" stroke="none"/><circle cx="8" cy="18" r="2" fill="currentColor" stroke="none"/></svg>',
    spinner: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 3a9 9 0 1 0 9 9" opacity="0.9"/></svg>',
    ticket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2 2 2 0 0 0 0 4 2 2 0 0 1-2 2H5a2 2 0 0 1-2-2 2 2 0 0 0 0-4z"/><path d="M14 6v12" stroke-dasharray="2 2"/></svg>',
    rupee: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 5h10M7 9h10M16 5c0 4-3 6-7 6l6 8"/></svg>',
  };
  const icon = (n) => ICONS[n] || "";

  /* ---------- State ---------- */
  let DATA = null;
  const state = {
    colorId: null,
    sizeId: null,
    mediaIndex: 0,
    offerMode: "code",   // code | automatic | none
    qty: 1,
    wishlist: false,
    discountFail: false, // demo: force coupon to fail in bag
  };

  /* ---------- Money (minor units -> ₹, Indian grouping) ---------- */
  function money(minor) {
    const cur = (DATA && DATA.currency) || {};
    const sym = cur.symbol || "₹";
    const v = (minor || 0) / 100;
    const loc = cur.locale || "en-IN";
    const s = (v % 1 === 0) ? v.toLocaleString(loc)
      : v.toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return sym + s;
  }

  /* ---------- Variant helpers (real Shopify variants) ---------- */
  const color = (id) => DATA.product.options.color.find((c) => c.id === id);
  const size = (id) => DATA.product.options.size.find((s) => s.id === id);
  const hasColor = () => DATA.product.options.color.length > 0;
  const hasSize = () => DATA.product.options.size.length > 0;
  function variantFor(colorId, sizeId) {
    return (DATA.product.variants || []).find((v) =>
      (!hasColor() || v.color === colorId) && (!hasSize() || v.size === sizeId));
  }
  function comboAvailable(colorId, sizeId) {
    return (DATA.product.variants || []).some((v) =>
      (!hasColor() || v.color === colorId) && (!hasSize() || v.size === sizeId) && v.available);
  }
  const colorAvailable = (id) => (DATA.product.variants || []).some((v) => v.color === id && v.available);
  const sizeAvailable = (id) => (DATA.product.variants || []).some((v) => v.size === id && v.available);
  const bothSelected = () => (!hasColor() || !!state.colorId) && (!hasSize() || !!state.sizeId);
  const currentVariant = () => variantFor(state.colorId, state.sizeId);
  function currentPrice() { const v = currentVariant(); return v && v.price != null ? v.price : DATA.product.price; }
  function currentCompareAt() { const v = currentVariant(); return v && v.compareAt != null ? v.compareAt : DATA.product.compareAtPrice; }

  /* ---------- Offer / effective-price logic (brief §10) ---------- */
  function computeOffer() {
    const price = currentPrice();
    const o = DATA.offer;
    if (state.offerMode === "none") return { eligible: false, showExact: false, effective: price, savings: 0 };
    let discount = 0, showExact = true;
    if (o.type === "fixed_amount") discount = o.value;
    else if (o.type === "percentage") {
      discount = Math.round(price * o.value / 100);
      if (o.maximumDiscount != null) discount = Math.min(discount, o.maximumDiscount);
    }
    const effective = Math.max(price - discount, 0);
    return {
      eligible: discount > 0,
      showExact,                 // exact per-variant price is knowable for simple fixed/percentage
      isCode: state.offerMode === "code",
      code: o.code,
      effective, savings: discount,
    };
  }

  /* ---------- a11y live region ---------- */
  function announce(msg) { const l = $("#live"); if (l) { l.textContent = ""; setTimeout(() => (l.textContent = msg), 30); } }

  /* ---------- Analytics stub (brief §25) ---------- */
  function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event }, payload || {}));
    if (window.console) console.debug("[analytics]", event, payload || {});
  }

  /* ============================================================
     RENDERERS
     ============================================================ */
  function tmpl(str, map) { return str.replace(/\{(\w+)\}/g, (_, k) => (k in map ? map[k] : "")); }

  function renderStatic() {
    const p = DATA.product;
    const bw = $("#brandWord"); if (bw) bw.textContent = p.vendor;
    const note = $("#colorNote"); if (note) note.textContent = p.colorNote || "";
    const an = $("#announceText"); if (an && DATA.announcement) an.textContent = DATA.announcement;
  }

  function renderGallery() {
    const media = DATA.product.media;
    const track = $("#galleryTrack");
    track.innerHTML = media.map((m, i) => `
      <div class="gallery__slide" role="group" aria-roledescription="slide" aria-label="Media ${i + 1} of ${media.length}">
        ${m.type === "video" ? `<span class="gallery__video-badge" aria-hidden="true">${icon("play")}</span>` : ""}
        <img src="${m.src}" alt="${m.alt || (DATA.product.title + " — media " + (i + 1))}"
             ${i === 0 ? 'fetchpriority="high"' : 'loading="lazy" decoding="async"'} />
      </div>`).join("");
    // dots
    $("#galleryDots").innerHTML = media.map((_, i) =>
      `<button class="gallery__dot${i === 0 ? " is-active" : ""}" data-goto="${i}" aria-label="Go to media ${i + 1}"></button>`).join("");
    // thumbs (desktop)
    $("#galleryThumbs").innerHTML = media.map((m, i) =>
      `<button class="gallery__thumb${i === 0 ? " is-active" : ""}" data-goto="${i}" aria-label="View media ${i + 1}"><img src="${m.src}" alt="" loading="lazy"></button>`).join("");

    // sync dots/thumbs on scroll
    track.addEventListener("scroll", () => {
      const idx = Math.round(track.scrollLeft / track.clientWidth);
      if (idx !== state.mediaIndex) { state.mediaIndex = idx; syncGallery(); }
    }, { passive: true });
  }
  function goToMedia(i) {
    const track = $("#galleryTrack");
    state.mediaIndex = Math.max(0, Math.min(i, DATA.product.media.length - 1));
    track.scrollTo({ left: state.mediaIndex * track.clientWidth, behavior: "smooth" });
    syncGallery();
  }
  function syncGallery() {
    $$("#galleryDots .gallery__dot").forEach((d, i) => d.classList.toggle("is-active", i === state.mediaIndex));
    $$("#galleryThumbs .gallery__thumb").forEach((t, i) => t.classList.toggle("is-active", i === state.mediaIndex));
  }

  function renderHeaderInfo() {
    const p = DATA.product, s = DATA.social;
    // badges
    $("#badges").innerHTML =
      (p.badges.coupon ? `<span class="badge badge--coupon">${p.badges.coupon}</span>` : "") +
      (p.badges.popularity ? `<span class="badge badge--pop">${p.badges.popularity}</span>` : "");
    // title + vendor
    $("#vendor").textContent = p.vendor;
    $("#title").textContent = p.title;
    // rating badge
    if (s && s.rating) {
      $("#ratingBadge").innerHTML =
        `<span class="rating-badge__score">${icon("star")} ${s.rating}</span>
         <span class="rating-badge__count">${s.ratingCount} ratings</span>`;
      $("#ratingBadge").hidden = false;
    } else { $("#ratingBadge").hidden = true; }
  }

  function renderPrice() {
    const p = DATA.product;
    const price = currentPrice(), compareAt = currentCompareAt();
    const showCompare = compareAt && compareAt > price;
    const pct = showCompare ? Math.round((1 - price / compareAt) * 100) : 0;
    $$("#price, [data-render='price']").forEach((el) => {
      el.innerHTML =
        `<span class="price-now">${money(price)}</span>` +
        (showCompare ? `<span class="price-was">${money(compareAt)}</span><span class="price-off">${pct}% off</span>` : "") +
        (p.taxNote ? `<span class="price-tax">${p.taxNote}</span>` : "");
    });
  }

  function renderOffer() {
    const card = $("#offerCard");
    const o = computeOffer();
    if (!o.eligible) { card.hidden = true; return; }
    card.hidden = false;
    const priceTxt = money(o.effective);
    const title = tmpl(DATA.offer.title, { price: priceTxt });
    const meta = o.isCode ? tmpl(DATA.offer.label, { code: o.code }) : "Automatically applied in your bag";
    card.innerHTML = `
      <span class="offer-card__icon" aria-hidden="true">${icon("discount")}</span>
      <span class="offer-card__body">
        <span class="offer-card__price">${title}</span>
        <span class="offer-card__meta">${meta}</span>
      </span>
      <button class="link-underline offer-card__how" data-open="couponSheet" aria-haspopup="dialog">How?</button>`;
  }

  function renderColors() {
    const p = DATA.product;
    $$('[data-render="colorname"]').forEach((el) => {
      el.innerHTML = state.colorId
        ? `<span class="selector__label">${color(state.colorId).name}</span>`
        : `<span class="selector__label">Colour</span>`;
    });
    const html = p.options.color.map((c) => {
      const selected = c.id === state.colorId;
      const outline = c.needsOutline ? "box-shadow: inset 0 0 0 1px var(--vamora-line);" : "";
      return `<button class="swatch" role="radio" data-color="${c.id}"
        aria-checked="${selected}" aria-disabled="${!c.available}" ${!c.available ? 'tabindex="-1"' : ""}
        aria-label="${c.name}${!c.available ? " (sold out)" : ""}" title="${c.name}">
        <span class="swatch__dot" style="background:${c.hex};${outline}"></span></button>`;
    }).join("");
    $$('[data-render="colors"]').forEach((el) => { el.setAttribute("role", "radiogroup"); el.setAttribute("aria-label", "Colour"); el.innerHTML = html; });
  }

  function renderSizes() {
    const p = DATA.product;
    const html = p.options.size.map((s) => {
      const selected = s.id === state.sizeId;
      const available = s.available && (!state.colorId || comboAvailable(state.colorId, s.id));
      return `<button class="size" role="radio" data-size="${s.id}"
        aria-checked="${selected}" aria-disabled="${!available}" ${!available ? 'tabindex="-1"' : ""}
        aria-label="Size ${s.name}${!available ? " (unavailable)" : ""}${s.fastDelivery && available ? ", fast delivery" : ""}">
        ${s.fastDelivery ? `<span class="size__bolt" aria-hidden="true">${icon("bolt")}</span>` : ""}${s.name}</button>`;
    }).join("");
    $$('[data-render="sizes"]').forEach((el) => { el.setAttribute("role", "radiogroup"); el.setAttribute("aria-label", "Size"); el.innerHTML = html; });
    const anyFast = p.options.size.some((s) => s.fastDelivery);
    $$('[data-render="fast"]').forEach((el) => { el.hidden = !anyFast; });
  }

  function renderDelivery() {
    const d = DATA.product.delivery;
    const s = state.sizeId ? size(state.sizeId) : null;
    const fast = s && s.fastDelivery && comboAvailable(state.colorId, state.sizeId);
    const msg = fast ? d.fastEstimate : d.defaultEstimate;
    $$('[data-render="delivery"]').forEach((el) => {
      el.innerHTML = `${icon("truck")}<span><b>${msg}</b>${!state.sizeId ? " · " + d.pincodeHint : ""}</span>`;
    });
  }

  /* ---------- Purchase docks (3 instances, one state) ---------- */
  function purchaseMarkup() {
    const o = computeOffer();
    const exact = o.eligible && o.showExact;
    const buyLabel = exact ? `Buy Now · ${money(o.effective)}` : "Buy Now";
    return `
      <div class="purchase-actions">
        <button class="btn btn--primary ${exact ? "" : "is-tagless"}" data-action="buy" type="button" aria-label="Buy now${exact ? " for " + money(o.effective) : ""}">
          <span class="btn__shine" aria-hidden="true"></span>
          <span class="btn__tag">Best offer</span>
          <span class="btn__label">${buyLabel}</span>
          <span class="btn__spinner" aria-hidden="true">${icon("spinner")}</span>
        </button>
        <button class="btn btn--outline" data-action="add" type="button">
          <span class="btn__label">Add to Bag</span>
          <span class="btn__spinner" aria-hidden="true">${icon("spinner")}</span>
        </button>
      </div>`;
  }
  function updateDocks() {
    const markup = purchaseMarkup();
    const pop = DATA.product.badges.popularity ? `${DATA.product.badges.popularity} · ${DATA.social.loveLine}` : "";
    ["#floatingInner", "#inlineInner", "#desktopInner"].forEach((sel) => { const el = $(sel); if (el) el.innerHTML = markup; });
    $$('[data-render="pop"]').forEach((el) => { el.textContent = pop; });
  }

  /* ---------- Reviews / fit / UGC / trust / tabs / recs ---------- */
  function starRow(rating, cls) {
    let out = "";
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) out += icon("star");
      else if (rating >= i - 0.5) out += icon("starHalf");
      else out += icon("starOutline");
    }
    return `<span class="${cls || ""}">${out}</span>`;
  }
  function renderReviewsHero() {
    const s = DATA.social;
    $("#reviewsHero").innerHTML = `
      <h2 class="section-title">Ratings &amp; Reviews</h2>
      <p class="reviews-hero__count">${s.ratingCount} ratings · ${s.reviewCount} reviews</p>
      <div class="reviews-hero__score">
        <span class="reviews-hero__wreath" aria-hidden="true">${icon("laurelL")}</span>
        <span class="num">${s.rating}</span>
        <span class="reviews-hero__wreath" aria-hidden="true">${icon("laurelR")}</span>
      </div>
      <p class="reviews-hero__love">${s.loveLine}</p>`;
  }
  function renderFit() {
    const list = DATA.social.fitIntelligence;
    $("#fitList").innerHTML = list.map((f) => `
      <div class="fit-item">
        <span class="fit-item__label">${f.attr}</span>
        <span class="fit-item__value">${f.label} (${f.pct}%)</span>
        <span class="fit-item__bar"><span class="fit-item__fill" style="width:${f.pct}%"></span></span>
      </div>`).join("");
  }
  function renderUGC() {
    const host = $("#ugcScroll"); if (!host) return;
    const items = DATA.ugc || [];
    host.innerHTML = items.map((u, i) => `
      <button class="ugc-tile" data-lightbox="${u.src}" aria-label="Open customer ${u.type} ${i + 1}">
        <img src="${u.src}" alt="${u.alt}" loading="lazy">
        ${u.type === "video" ? `<span class="ugc-tile__play" aria-hidden="true">${icon("play")}</span>` : ""}
      </button>`).join("");
    revealSection(host, items.length > 0);
  }
  function reviewCard(r) {
    return `<article class="review-card">
      <div class="review-card__top">
        <span class="review-card__stars" aria-label="${r.rating} out of 5">${starRow(r.rating)}</span>
        <span class="review-card__date">${r.date}</span>
      </div>
      <h4 class="review-card__title">${r.title}</h4>
      <p class="review-card__text">${r.text}</p>
      <div class="review-card__foot">
        <span class="review-card__buyer">${r.verified ? icon("verified") + " Verified Buyer" : "Buyer"} · ${r.name}</span>
        <span class="review-card__size">Size: ${r.size}</span>
      </div>
    </article>`;
  }
  function renderReviewList() {
    const rv = DATA.reviews;
    $("#reviewHead").innerHTML = `
      <div>
        <h2 class="section-title">Reviews (${rv.count})</h2>
        <span class="review-stars" aria-label="${rv.stars} out of 5">${starRow(rv.stars)} <b>(${rv.stars})</b></span>
      </div>
      <button class="link-underline" data-open="reviewsSheet" aria-haspopup="dialog">See all</button>`;
    $("#reviewCards").innerHTML = rv.items.slice(0, 4).map(reviewCard).join("");
  }
  function revealSection(el, show) { const sec = el && el.closest("[data-vamora-trust],[data-vamora-tabs],[data-vamora-ugc]"); if (sec) sec.hidden = !show; }
  function renderTrust() {
    const host = $("#trust"); if (!host) return;
    const items = DATA.trust || [];
    host.innerHTML = items.map((t, i) => `
      <button class="trust-item" data-trust="${i}" aria-haspopup="dialog">
        ${icon(t.icon === "return" ? "ret" : t.icon === "shipping" ? "truck" : "cod")}
        <span class="trust-item__h">${t.heading}</span>
        <span class="trust-item__t">${t.text}</span>
      </button>`).join("");
    revealSection(host, items.length > 0);
  }
  function renderTabs() {
    const list = $("#tabList"); if (!list) return;
    const tabs = (DATA.product.details && DATA.product.details.tabs) || [];
    list.innerHTML = tabs.map((t, i) =>
      `<button class="tab" role="tab" id="tab-${t.id}" aria-controls="panel-${t.id}" aria-selected="${i === 0}" data-tab="${t.id}">${t.label}</button>`).join("");
    $("#tabPanels").innerHTML = tabs.map((t, i) => {
      const inner = (t.specs && t.specs.length)
        ? `<div class="specs">${t.specs.map((s) => `<div class="spec"><div class="spec__k">${s.label}</div><div class="spec__v">${s.value}</div></div>`).join("")}</div>`
        : `<div class="tab-rte">${t.html || ""}</div>`;
      return `<div role="tabpanel" id="panel-${t.id}" aria-labelledby="tab-${t.id}" ${i === 0 ? "" : "hidden"}>${inner}</div>`;
    }).join("");
    revealSection(list, tabs.length > 0);
  }
  function recCard(r) {
    const showCompare = r.compareAtPrice && r.compareAtPrice > r.price;
    const colors = (r.colors || []).slice(0, 4).map((c) => `<span class="rec-card__color" style="background:${c}"></span>`).join("");
    const more = (r.colors || []).length > 4 ? `<span class="rec-card__more">+${r.colors.length - 4}</span>` : "";
    return `<div class="rec-card">
      <a class="rec-card__media" href="#" aria-label="${r.title}">
        <img src="${r.image}" alt="${r.title}" loading="lazy">
        <button class="rec-card__wish" aria-label="Save ${r.title} to wishlist" aria-pressed="false" data-recwish>${icon("heart")}</button>
        <button class="rec-card__quick" aria-label="Quick add ${r.title}" data-recadd>${icon("plus")}</button>
      </a>
      <div class="rec-card__title">${r.title}</div>
      <div class="rec-card__price"><span class="rec-card__now">${money(r.price)}</span>${showCompare ? `<span class="rec-card__was">${money(r.compareAtPrice)}</span>` : ""}</div>
      <div class="rec-card__colors">${colors}${more}</div>
    </div>`;
  }
  function renderRecs() {
    const rec = DATA.recommendations;
    $("#recSimilar").innerHTML = `<h2 class="section-title">${rec.similarTitle}</h2><p class="eyebrow">${rec.similarSub}</p>
      <div class="rec-grid">${rec.similar.map(recCard).join("")}</div>`;
    $("#recComplete").innerHTML = `<h2 class="section-title">${rec.completeTitle}</h2><p class="eyebrow">${rec.completeSub}</p>
      <div class="rec-grid">${rec.complete.map(recCard).join("")}</div>`;
  }

  /* ============================================================
     SHEETS + MODALS (generic controller with focus trap)
     ============================================================ */
  const Sheet = {
    lastFocused: null,
    openId: null,
    open(id, opener) {
      buildSheet(id);
      const el = $("#" + id);
      if (!el) return;
      this.lastFocused = opener || document.activeElement;
      $("#overlay").classList.add("is-open");
      el.hidden = false;
      // force reflow then animate
      void el.offsetWidth;
      el.classList.add("is-open");
      document.body.style.overflow = "hidden";
      $("#app").setAttribute("aria-hidden", "true");
      this.openId = id;
      const focusTarget = el.querySelector("[data-autofocus]") || el.querySelector(".sheet__close, .cart__close") || el;
      focusTarget.focus();
      track("open_" + id);
    },
    close() {
      const el = this.openId && $("#" + this.openId);
      $("#overlay").classList.remove("is-open");
      if (el) {
        el.classList.remove("is-open");
        setTimeout(() => { el.hidden = true; }, 300);
      }
      document.body.style.overflow = "";
      $("#app").removeAttribute("aria-hidden");
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
      this.openId = null;
    },
  };

  function trapTab(e) {
    if (e.key !== "Tab" || !Sheet.openId) return;
    const container = $("#" + Sheet.openId);
    const f = $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter((el) => !el.disabled && el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Per-sheet content builders ---------- */
  let sizeUnit = "in";
  function buildSheet(id) {
    if (id === "couponSheet") return buildCoupon();
    if (id === "sizeSheet") return buildSizeGuide();
    if (id === "validationSheet") return buildValidation();
    if (id === "insightsSheet") return buildInsights();
    if (id === "reviewsSheet") return buildReviews();
    if (id === "cart") return; // built on add
  }

  function buildCoupon() {
    const o = computeOffer();
    const priceTxt = money(o.effective);
    const heading = tmpl(DATA.offer.popupHeading, { price: priceTxt });
    const body = $("#couponBody");
    if (o.isCode) {
      body.innerHTML = `
        <div class="coupon-hero">
          <span class="coupon-hero__icon" aria-hidden="true">${icon("rupee")}</span>
          <h3 class="coupon-hero__h" id="couponSheetTitle">${heading}</h3>
          <p class="coupon-hero__sub">${DATA.offer.popupSub}</p>
        </div>
        <div class="timeline">
          <div class="timeline__item"><div class="timeline__k">${money(DATA.product.compareAtPrice)}</div><div class="timeline__sub">Maximum retail price</div></div>
          <div class="timeline__item"><div class="timeline__k">${money(DATA.product.price)}</div><div class="timeline__sub">VAMORA price</div>
            <div class="coupon-card">
              <div><b>Save ${money(o.savings)}</b> with coupon</div>
              <div class="coupon-card__code">
                <span class="coupon-code" id="couponCode">${o.code}</span>
                <button class="btn btn--outline copy-btn" style="height:40px;flex:0 0 auto;padding:0 14px" data-copy="${o.code}">${icon("copy")} <span class="copy-btn__label">Copy code</span></button>
              </div>
            </div>
          </div>
          <div class="timeline__item is-final"><div class="timeline__k">${priceTxt}</div><div class="timeline__sub">Effective price</div></div>
        </div>
        <p class="coupon-disclaimer">${DATA.offer.disclaimer}</p>`;
      $("#couponFoot").innerHTML = `<button class="btn btn--primary btn--full" data-action="add" data-autofocus>Add to Bag &amp; apply</button>`;
    } else {
      // automatic offer: no code shown
      body.innerHTML = `
        <div class="coupon-hero">
          <span class="coupon-hero__icon" aria-hidden="true">${icon("rupee")}</span>
          <h3 class="coupon-hero__h" id="couponSheetTitle">${heading}</h3>
          <p class="coupon-hero__sub">This offer is applied automatically — no code needed.</p>
        </div>
        <div class="timeline">
          <div class="timeline__item"><div class="timeline__k">${money(DATA.product.compareAtPrice)}</div><div class="timeline__sub">Maximum retail price</div></div>
          <div class="timeline__item"><div class="timeline__k">${money(DATA.product.price)}</div><div class="timeline__sub">VAMORA price</div></div>
          <div class="timeline__item is-final"><div class="timeline__k">${priceTxt}</div><div class="timeline__sub">With the automatic VAMORA offer</div></div>
        </div>
        <p class="coupon-disclaimer">${DATA.offer.disclaimer}</p>`;
      $("#couponFoot").innerHTML = `<button class="btn btn--primary btn--full" data-action="add" data-autofocus>Add to Bag</button>`;
    }
  }

  function buildSizeGuide() {
    const g = DATA.product.sizeGuide;
    const rows = g.rows[sizeUnit];
    $("#sizeBody").innerHTML = `
      <h3 class="section-title" style="margin-bottom:6px">Size Guide</h3>
      <div class="seg" role="group" aria-label="Units">
        <button class="seg__btn" data-unit="in" aria-pressed="${sizeUnit === "in"}" data-autofocus>${g.units.in}</button>
        <button class="seg__btn" data-unit="cm" aria-pressed="${sizeUnit === "cm"}">${g.units.cm}</button>
      </div>
      <p class="eyebrow" style="margin-top:16px">Body size</p>
      <p style="color:var(--vamora-muted);font-size:13px;margin:4px 0 0">${g.intro}</p>
      <div class="size-table-wrap">
        <table class="size-table">
          <thead><tr>${g.columns.map((c) => `<th>${c}${c !== "Size" ? " (" + sizeUnit.toUpperCase() + ")" : ""}</th>`).join("")}</tr></thead>
          <tbody>${rows.map((r) => `<tr>${r.map((cell, i) => (i === 0 ? `<th scope="row">${cell}</th>` : `<td>${cell}</td>`)).join("")}</tr>`).join("")}</tbody>
        </table>
      </div>
      <div class="howto">
        <p class="eyebrow">How to measure</p>
        ${g.howTo.map((h) => `<div class="howto__item"><b>${h.label}.</b> <span>${h.text}</span></div>`).join("")}
      </div>
      <div class="model-info">
        <p class="eyebrow" style="margin-bottom:6px">Model &amp; fit</p>
        <div class="model-info__row">${g.model.height}</div>
        <div class="model-info__row">${g.model.wearing}</div>
        <div class="model-info__row" style="color:var(--vamora-muted)">${g.model.measurements}</div>
      </div>
      <p class="fit-note">${g.fitNote}</p>`;
  }

  function buildValidation() {
    $("#validationBody").innerHTML = `
      <div class="selector" style="margin-top:0">
        <div class="selector__head"><span data-render="colorname"></span></div>
        <p class="selector__note">${DATA.product.colorNote}</p>
        <div class="swatches" data-render="colors"></div>
      </div>
      <div class="selector">
        <div class="selector__head">
          <span class="selector__label">Select size</span>
          <button class="link-underline" data-open="sizeSheet" aria-haspopup="dialog">Size guide &amp; model info</button>
        </div>
        <div class="sizes" data-render="sizes"></div>
        <div class="fast-note" data-render="fast">${icon("bolt")}<span>Sizes with a bolt are available for fast delivery in your area.</span></div>
      </div>
      <div class="delivery" data-render="delivery" style="margin-top:16px"></div>
      <p class="form-error" id="validationError" role="alert"></p>`;
    $("#validationFoot").innerHTML = `<button class="btn btn--primary btn--full" data-action="add" data-from="validation" data-autofocus>Add to Bag</button>`;
    // populate the freshly-injected pickers from state
    renderColors(); renderSizes(); renderDelivery();
  }

  function buildInsights() {
    const dist = DATA.social.fitDistributions;
    $("#insightsBody").innerHTML = Object.keys(dist).map((attr) => `
      <div class="dist__group">
        <div class="dist__title">${attr}</div>
        ${dist[attr].map((d) => `
          <div class="dist__row">
            <span>${d.label}</span>
            <span class="dist__bar"><span class="dist__fill" style="width:${d.pct}%"></span></span>
            <span><b>${d.pct}%</b></span>
          </div>`).join("")}
      </div>`).join("");
  }

  let reviewFilter = "all";
  function buildReviews() {
    const rv = DATA.reviews;
    const items = reviewFilter === "images" ? rv.items.filter((r) => r.hasImage) : rv.items;
    $("#reviewsBody").innerHTML = `
      <div class="rev-filters" role="group" aria-label="Filter reviews">
        <button class="chip" data-filter="all" aria-pressed="${reviewFilter === "all"}" data-autofocus>All reviews</button>
        <button class="chip" data-filter="images" aria-pressed="${reviewFilter === "images"}">With images</button>
      </div>
      <div class="rev-list">${items.map(reviewCard).join("")}</div>`;
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  }
  function cartImg(url, w) {
    if (!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + (w || 160);
  }
  function openCartShell() {
    $("#overlay").classList.add("is-open");
    const cart = $("#cart");
    cart.hidden = false; void cart.offsetWidth; cart.classList.add("is-open");
    document.body.style.overflow = "hidden";
    const app = $("#app"); if (app) app.setAttribute("aria-hidden", "true");
    Sheet.openId = "cart"; Sheet.lastFocused = document.activeElement;
    const c = $("#cartClose"); if (c) c.focus();
  }
  function openCart() {
    openCartShell();
    $("#cartBody").innerHTML = `<div class="cart-success">${icon("spinner")} Updating your bag…</div>`;
    fetch(DATA.routes.cart, { headers: { "Accept": "application/json" } })
      .then((r) => r.json()).then(renderCart)
      .catch(() => { $("#cartBody").innerHTML = `<p class="form-error is-shown">Could not load your bag. Please try again.</p>`; });
    track("add_to_cart");
  }
  function renderCart(cart) {
    const threshold = (DATA.cart && DATA.cart.freeShipThreshold) || 0;
    const total = cart.total_price, subtotal = cart.items_subtotal_price, totalDiscount = cart.total_discount || 0;
    const pct = threshold ? Math.min(100, Math.round(total / threshold * 100)) : 100;
    const remaining = Math.max(0, threshold - total);
    const lines = (cart.items || []).map((it, i) => {
      const opts = (it.options_with_values || []).map((ov) => ov.value).join(" · ");
      return `<div class="cart-line">
        <span class="cart-line__img">${it.image ? `<img src="${cartImg(it.image, 160)}" alt="${escapeHtml(it.product_title)}">` : ""}</span>
        <div>
          <div class="cart-line__title">${escapeHtml(it.product_title)}</div>
          <div class="cart-line__price"><span class="cart-line__now">${money(it.final_line_price)}</span>${it.original_line_price > it.final_line_price ? `<span class="cart-line__was">${money(it.original_line_price)}</span>` : ""}</div>
          ${opts ? `<div class="cart-line__meta">${escapeHtml(opts)}</div>` : ""}
          <div class="qty" role="group" aria-label="Quantity">
            <button data-cart-line="${i + 1}" data-cart-qty="${it.quantity - 1}" aria-label="Decrease quantity">${icon("minus")}</button>
            <span aria-live="polite">${it.quantity}</span>
            <button data-cart-line="${i + 1}" data-cart-qty="${it.quantity + 1}" aria-label="Increase quantity">${icon("plus")}</button>
          </div>
        </div>
        <button class="cart-line__remove" data-cart-line="${i + 1}" data-cart-qty="0" aria-label="Remove item">${icon("close")}</button>
      </div>`;
    }).join("");
    const couponNote = (DATA.offer && DATA.offer.mode === "code" && DATA.offer.code)
      ? `<div class="cart-row"><span>Coupon ${escapeHtml(DATA.offer.code)}</span><span class="save">Applied at checkout</span></div>` : "";
    $("#cartBody").innerHTML = `
      <div class="cart-success">${icon("check")} Added to your bag</div>
      ${(cart.item_count === 0) ? `<p style="color:var(--vamora-muted)">Your bag is empty.</p>` : lines}
      ${threshold && cart.item_count ? `<div class="ship-progress">
        <div class="cart-note">${icon("truck")} ${remaining > 0 ? `Add ${money(remaining)} for free shipping` : "You’ve unlocked free shipping"}</div>
        <div class="ship-progress__track"><div class="ship-progress__fill" style="width:${pct}%"></div></div>
      </div>` : ""}
      ${cart.item_count ? `<div class="cart-row"><span>Subtotal</span><span>${money(subtotal)}</span></div>
      ${totalDiscount > 0 ? `<div class="cart-row"><span>Discounts</span><span class="save">- ${money(totalDiscount)}</span></div>` : ""}
      ${couponNote}
      <div class="cart-row cart-row--total"><span>Total</span><span>${money(total)}</span></div>` : ""}`;
    $("#cartFoot").innerHTML = cart.item_count ? `
      <div class="cart-note">${icon("ret")} ${escapeHtml((DATA.cart && DATA.cart.returnNote) || "Easy return & exchange")}</div>
      <a class="btn btn--outline btn--full" href="${DATA.routes.cartPage}">View Bag</a>
      <a class="btn btn--primary btn--full" href="${DATA.routes.checkout}">Checkout · ${money(total)}</a>` : "";
    announce("Bag updated. " + (cart.item_count ? "Total " + money(total) : "Your bag is empty."));
  }
  function changeCartLine(line, qty) {
    const body = $("#cartBody"); if (body) body.style.opacity = "0.5";
    fetch(DATA.routes.cartChange, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then((r) => r.json()).then((cart) => { if (body) body.style.opacity = ""; renderCart(cart); updateCartCount(); })
      .catch(() => { if (body) body.style.opacity = ""; });
  }

  /* ============================================================
     PURCHASE FLOW
     ============================================================ */
  function requireSelection(fromValidation) {
    if (!bothSelected()) {
      const need = [hasColor() && !state.colorId ? "colour" : null, hasSize() && !state.sizeId ? "size" : null].filter(Boolean).join(" and ");
      if (!fromValidation) Sheet.open("validationSheet");
      else flashValidationError("Please select a " + (need || "variant") + ".");
      return false;
    }
    if (!comboAvailable(state.colorId, state.sizeId)) {
      const parts = [];
      if (hasColor() && color(state.colorId)) parts.push(color(state.colorId).name);
      if (hasSize() && size(state.sizeId)) parts.push(size(state.sizeId).name);
      const msg = "Sorry, " + (parts.join(" / ") || "this variant") + " is sold out.";
      if (Sheet.openId === "validationSheet") flashValidationError(msg);
      else showToast(msg);
      return false;
    }
    return true;
  }
  function flashValidationError(msg) {
    const e = $("#validationError"); if (!e) return;
    e.textContent = msg; e.classList.add("is-shown"); announce(msg);
  }

  function ajaxAddToCart(variantId, qty) {
    return fetch(DATA.routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
    }).then((r) => r.json().then((j) => ({ ok: r.ok, j })));
  }
  function doAdd(btn) {
    if (!requireSelection(Sheet.openId === "validationSheet")) return;
    const v = currentVariant(); if (!v) return;
    setBtnLoading(btn, true);
    track("add_to_cart", { id: v.id });
    ajaxAddToCart(v.id, state.qty).then(({ ok, j }) => {
      setBtnLoading(btn, false);
      if (!ok) { const m = (j && (j.description || j.message)) || "Could not add to bag."; Sheet.openId === "validationSheet" ? flashValidationError(m) : showToast(m); return; }
      if (Sheet.openId === "validationSheet" || Sheet.openId === "couponSheet") Sheet.close();
      updateCartCount();
      setTimeout(openCart, Sheet.openId ? 320 : 0);
    }).catch(() => { setBtnLoading(btn, false); showToast("Network error — please try again."); });
  }
  function doBuy(btn) {
    if (!requireSelection(Sheet.openId === "validationSheet")) return;
    const v = currentVariant(); if (!v) return;
    setBtnLoading(btn, true);
    track("begin_checkout", { id: v.id });
    ajaxAddToCart(v.id, state.qty).then(({ ok, j }) => {
      if (!ok) { setBtnLoading(btn, false); showToast((j && (j.description || j.message)) || "Could not proceed."); return; }
      window.location.href = DATA.routes.checkout;
    }).catch(() => { setBtnLoading(btn, false); showToast("Network error — please try again."); });
  }
  // Keep the theme header cart count in sync
  function updateCartCount() {
    fetch(DATA.routes.cart, { headers: { "Accept": "application/json" } }).then((r) => r.json()).then((cart) => {
      document.querySelectorAll(".cart-count, [data-cart-count], .cart-count-bubble span[aria-hidden]").forEach((el) => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart } }));
    }).catch(() => {});
  }
  function setBtnLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle("is-loading", on);
    btn.disabled = on;
    // disable sibling to prevent duplicate submit
    const sib = btn.parentElement && btn.parentElement.querySelector("button:not(:disabled)");
    if (on && sib && sib !== btn) sib.disabled = true;
    if (!on) $$(".btn").forEach((b) => (b.disabled = false));
  }

  let toastTimer;
  function showToast(msg) {
    const t = $("#toast"); if (!t) return; t.textContent = msg; t.classList.add("is-shown");
    announce(msg);
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove("is-shown"), 2600);
  }
  function openLightbox(src) {
    const root = $(".vamora-pdp") || document.body;
    let lb = document.getElementById("vamoraLightbox");
    if (!lb) {
      lb = document.createElement("div");
      lb.id = "vamoraLightbox"; lb.className = "overlay"; lb.style.zIndex = "80";
      lb.innerHTML = '<img alt="" style="max-width:92vw;max-height:88vh;position:absolute;inset:0;margin:auto;border-radius:12px">';
      lb.addEventListener("click", () => { lb.classList.remove("is-open"); document.body.style.overflow = ""; });
      root.appendChild(lb);
    }
    lb.querySelector("img").src = src;
    lb.classList.add("is-open"); document.body.style.overflow = "hidden";
    track("view_customer_media");
  }

  /* ============================================================
     STICKY -> INLINE DOCKING (brief §14)
     ============================================================ */
  let activeDock = "floating";
  function setActiveDock(which) {
    activeDock = which;
    const floating = $("#floatingBar"), inlineWrap = $("#inlineDockWrap");
    const floatOn = which === "floating";
    const inlineOn = which === "inline";
    floating.classList.toggle("is-hidden", !floatOn);
    floating.toggleAttribute("inert", !floatOn);
    floating.setAttribute("aria-hidden", String(!floatOn));
    inlineWrap.toggleAttribute("inert", !inlineOn);
    inlineWrap.setAttribute("aria-hidden", String(!inlineOn));
  }
  function isDesktopTwoCol() {
    const root = document.querySelector(".vamora-pdp");
    const mode = root ? root.getAttribute("data-desktop") : null;
    return window.innerWidth >= 990 && mode !== "canvas";
  }
  // Scroll-driven docking from the inline bar's live position (works even where
  // IntersectionObserver callbacks are throttled). Not brittle fixed pixels —
  // it reads the element's current rect each time.
  function updateDockFromScroll() {
    if (isDesktopTwoCol()) return;           // desktop keeps actions in the sticky column
    const wrap = $("#inlineDockWrap");
    if (!wrap) return;
    const r = wrap.getBoundingClientRect();
    const vh = window.innerHeight;
    if (r.bottom < 8) setActiveDock("none");          // inline bar passed above -> no bar over recs
    else if (r.top < vh - 80) setActiveDock("inline"); // inline bar on screen -> dock into it
    else setActiveDock("floating");                    // still above the inline bar
  }
  function initDocking() {
    // Primary: IntersectionObserver (per brief §14). Enhancement/fallback:
    // a scroll+resize handler so docking is reliable in every environment.
    const target = $("#inlineDockWrap");
    try {
      const io = new IntersectionObserver(() => updateDockFromScroll(),
        { rootMargin: "0px 0px -80px 0px", threshold: [0, 0.01, 1] });
      io.observe(target);
    } catch (e) { /* no IO support -> scroll handler covers it */ }
    window.addEventListener("scroll", updateDockFromScroll, { passive: true });
    window.addEventListener("resize", updateDockFromScroll);
    updateDockFromScroll();
  }

  /* ============================================================
     EVENTS (delegation)
     ============================================================ */
  function wireEvents() {
    // header solidify on scroll (only if the section renders its own header)
    const header = $("#pdpHeader");
    if (header) window.addEventListener("scroll", () => {
      header.classList.toggle("is-solid", window.scrollY > 280);
    }, { passive: true });

    // global click delegation
    document.addEventListener("click", (e) => {
      const t = e.target.closest("[data-goto],[data-color],[data-size],[data-action],[data-open],[data-close],[data-copy],[data-unit],[data-tab],[data-trust],[data-filter],[data-cart-line],[data-recadd],[data-recwish],[data-lightbox],#galleryPrev,#galleryNext,#wishlist,.rating-badge");
      if (!t) return;

      if (t.id === "galleryPrev") return goToMedia(state.mediaIndex - 1);
      if (t.id === "galleryNext") return goToMedia(state.mediaIndex + 1);
      if (t.hasAttribute("data-goto")) return goToMedia(+t.getAttribute("data-goto"));
      if (t.id === "wishlist") { state.wishlist = !state.wishlist; t.setAttribute("aria-pressed", state.wishlist); t.innerHTML = icon(state.wishlist ? "heartFill" : "heart"); return; }

      if (t.classList.contains("rating-badge")) { $("#reviewsSection").scrollIntoView({ behavior: "smooth" }); track("view_reviews"); return; }

      if (t.hasAttribute("data-color")) return selectColor(t.getAttribute("data-color"), t);
      if (t.hasAttribute("data-size")) return selectSize(t.getAttribute("data-size"), t);

      if (t.hasAttribute("data-action")) {
        const a = t.getAttribute("data-action");
        if (a === "add") return doAdd(t);
        if (a === "buy") return doBuy(t);
      }
      if (t.hasAttribute("data-open")) { const id = t.getAttribute("data-open"); if (id && id !== "none") Sheet.open(id, t); return; }
      if (t.hasAttribute("data-close")) return Sheet.close();
      if (t.hasAttribute("data-copy")) return copyCode(t);
      if (t.hasAttribute("data-unit")) { sizeUnit = t.getAttribute("data-unit"); buildSizeGuide(); return; }
      if (t.hasAttribute("data-tab")) return selectTab(t.getAttribute("data-tab"));
      if (t.hasAttribute("data-trust")) return openTrust(+t.getAttribute("data-trust"), t);
      if (t.hasAttribute("data-filter")) { reviewFilter = t.getAttribute("data-filter"); buildReviews(); track("view_reviews", { filter: reviewFilter }); return; }
      if (t.hasAttribute("data-cart-line")) { e.preventDefault(); return changeCartLine(+t.getAttribute("data-cart-line"), +t.getAttribute("data-cart-qty")); }
      if (t.hasAttribute("data-recadd")) {
        e.preventDefault();
        const vid = t.getAttribute("data-variant-id");
        if (vid) { ajaxAddToCart(+vid, 1).then(({ ok, j }) => { if (ok) { updateCartCount(); openCart(); } else showToast((j && j.description) || "Could not add."); }); track("select_recommendation"); }
        return;
      }
      if (t.hasAttribute("data-recwish")) { const on = t.getAttribute("aria-pressed") !== "true"; t.setAttribute("aria-pressed", on); t.innerHTML = icon(on ? "heartFill" : "heart"); return; }
      if (t.hasAttribute("data-lightbox")) { const src = t.getAttribute("data-lightbox"); if (src) openLightbox(src); return; }
    });

    // overlay click closes topmost sheet/cart
    $("#overlay").addEventListener("click", () => Sheet.close());

    // keyboard: Esc + Tab trap + arrow nav for radios
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && Sheet.openId) { e.preventDefault(); return Sheet.close(); }
      if (e.key === "Tab") return trapTab(e);
      if ((e.key === "ArrowRight" || e.key === "ArrowLeft") && e.target.matches(".swatch,.size")) {
        const group = e.target.closest("[role='radiogroup']");
        const items = $$("[role='radio']:not([aria-disabled='true'])", group);
        const idx = items.indexOf(e.target);
        const next = items[(idx + (e.key === "ArrowRight" ? 1 : items.length - 1)) % items.length];
        if (next) { next.focus(); next.click(); }
      }
    });

    // keyboard activate for role=radio via Enter/Space handled natively (buttons)
    window.addEventListener("resize", () => { const gt = $("#galleryTrack"); if (gt) gt.scrollLeft = state.mediaIndex * gt.clientWidth; });
  }

  function selectColor(id, el) {
    const c = color(id); if (!c || !c.available) return;
    state.colorId = id;
    renderColors(); renderSizes(); renderDelivery(); renderPrice(); renderOffer(); updateDocks(); syncGalleryToVariant();
    clearValidationError();
    announce("Colour " + c.name + " selected");
    track("select_item_variant", { color: id });
  }
  function selectSize(id, el) {
    const s = size(id); if (!s || !s.available) return;
    state.sizeId = id;
    renderSizes(); renderDelivery(); renderPrice(); renderOffer(); updateDocks();
    clearValidationError();
    const avail = !state.colorId || comboAvailable(state.colorId, id);
    announce("Size " + s.name + (avail ? " selected" : " selected, currently sold out in this colour"));
    track("select_item_variant", { size: id });
  }
  // Jump the gallery to the selected colour's variant image (if any)
  function syncGalleryToVariant() {
    const v = currentVariant();
    if (v && v.mediaIndex != null && v.mediaIndex >= 0) goToMedia(v.mediaIndex);
  }
  function clearValidationError() { const e = $("#validationError"); if (e) { e.textContent = ""; e.classList.remove("is-shown"); } }

  function selectTab(id) {
    $$("#tabList .tab").forEach((tab) => { const on = tab.getAttribute("data-tab") === id; tab.setAttribute("aria-selected", on); });
    $$("#tabPanels [role='tabpanel']").forEach((p) => { p.hidden = p.id !== "panel-" + id; });
  }
  function openTrust(i, opener) {
    const item = DATA.trust[i];
    $("#trustTitle").textContent = item.heading;
    $("#trustBody").innerHTML = `<p>${item.modal}</p>`;
    Sheet.open("trustSheet", opener);
  }
  function copyCode(btn) {
    const code = btn.getAttribute("data-copy");
    const done = () => { const l = btn.querySelector(".copy-btn__label"); if (l) l.textContent = "Copied!"; showToast("Coupon " + code + " copied"); track("copy_discount_code", { code }); setTimeout(() => { if (l) l.textContent = "Copy code"; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done);
    else done();
  }

  /* ============================================================
     INIT (production — reads the Liquid data island, wires real Shopify)
     ============================================================ */
  const COLOR_NAMES = {
    black: "#141414", white: "#ffffff", ivory: "#f1efe7", cream: "#f3ead9", beige: "#e3d5c0",
    sand: "#d8c3a5", camel: "#b9925a", tan: "#c19a6b", brown: "#6b4a34", espresso: "#4a3728",
    chocolate: "#3d2b1f", grey: "#8c877d", gray: "#8c877d", charcoal: "#36373a", silver: "#c7c7c7",
    red: "#b32d2d", maroon: "#5e1b23", burgundy: "#5e1b23", bordeaux: "#5e1b23", wine: "#5e1b23",
    pink: "#e6b7c1", rose: "#d98a9a", blush: "#e8c5c0", coral: "#e2735a", orange: "#d97b3a",
    yellow: "#e2c044", gold: "#c6a15b", mustard: "#c9a227", green: "#4a6b45", olive: "#6b6a3a",
    sage: "#9aa08a", teal: "#2f6f6a", blue: "#3a5a86", navy: "#26314a", denim: "#4a5f80",
    sky: "#8fb3d9", purple: "#6a4a86", lavender: "#b9a8d1", lilac: "#c7b8de", nude: "#e2c9b0",
    khaki: "#b3a480", mint: "#b8dbc9", peach: "#f2c4a5", mocha: "#7a5c48",
  };
  function nameToHex(name) {
    if (!name) return "#cccccc";
    const key = String(name).toLowerCase().replace(/[^a-z]/g, "");
    for (const k in COLOR_NAMES) { if (key.indexOf(k) > -1) return COLOR_NAMES[k]; }
    return "#cccccc";
  }
  function isLightHex(hex) {
    if (!hex || hex[0] !== "#") return false;
    let h = hex.slice(1); if (h.length === 3) h = h.split("").map((x) => x + x).join("");
    if (h.length < 6) return false;
    const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) > 232;
  }
  function enrich() {
    const p = DATA.product;
    p.options = p.options || {};
    p.options.color = p.options.color || [];
    p.options.size = p.options.size || [];
    p.variants = p.variants || [];
    p.options.color.forEach((c) => {
      c.available = colorAvailable(c.id);
      if (!c.hex) c.hex = nameToHex(c.name);
      if (c.needsOutline == null) c.needsOutline = isLightHex(c.hex);
    });
    const fast = (p.fastDeliverySizes || []).map((s) => String(s).toLowerCase());
    p.options.size.forEach((s) => {
      s.available = sizeAvailable(s.id);
      if (s.fastDelivery == null) s.fastDelivery = fast.indexOf(String(s.name).toLowerCase()) > -1;
    });
    // preselect when a single choice exists
    if (p.options.color.length === 1) state.colorId = p.options.color[0].id;
    if (p.options.size.length === 1) state.sizeId = p.options.size[0].id;
    state.offerMode = (DATA.offer && DATA.offer.mode) || "none";
  }
  let wired = false;
  function boot() {
    const dataEl = document.querySelector(".vamora-pdp-data");
    if (!dataEl) return;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    state.colorId = null; state.sizeId = null; state.mediaIndex = 0; state.qty = 1;
    enrich();
    renderStatic(); renderGallery(); renderHeaderInfo(); renderPrice(); renderOffer();
    renderColors(); renderSizes(); renderDelivery(); updateDocks();
    renderReviewsHero(); renderFit(); renderUGC(); renderReviewList(); renderTrust(); renderTabs();
    if (!wired) { wireEvents(); initDocking(); wired = true; }
    updateDockFromScroll();
    track("view_item", { id: DATA.product.id });
  }
  function init() { if (document.querySelector(".vamora-pdp")) boot(); }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  // Theme editor lifecycle: re-render when the section is (re)loaded
  document.addEventListener("shopify:section:load", (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector(".vamora-pdp")) boot();
  });
})();
